import { render, staticRenderFns } from "./carLgsList.vue?vue&type=template&id=a5c3a7ba"
import script from "./carLgsList.vue?vue&type=script&lang=js"
export * from "./carLgsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports